<template>
  <div>
    <!-- <van-nav-bar
      title="我的推广链接"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/agency')"

    /> -->
    <div class="agencybox">
      <div class="linkbox1">
        <p class="agency" style="padding-top: 5px; padding-bottom: 5px;">方法一：扫描二维码</p>
        <van-row justify="center">
          <van-col span="6"></van-col>
          <van-col span="12" style="">
            <div id="qrcode" class="agency_qrcode"></div>
          </van-col>
          <van-col span="6"></van-col>
        </van-row>
        <br>
        <br>
      </div>
      <br>
      <div class="linkbox2">
        <div class="agency">
          <p style="line-height: 0px; padding-bottom: 8px; padding-top: 15px; text-align: justify;">方法二：点击链接注册</p>
          <div v-for="(url, index) in agencyUrl" :key="index" class="url-container">
            <p class="url-text">{{ url }}</p>
            <van-button
              size="small"
              type="danger"
              @click="handleCopy(url)"
              class="copy-btn"
            >
              复制链接
            </van-button>
          </div>
        </div>
      </div>
      <br>
      <div class="linkbox2">
          <div class="agency">
          <p style="padding-bottom: 6px; padding-top: 6px;">
            方法三：注册页面输入推广码 <br />
          </p>
          <p><span style="color: #EE5C35; text-decoration: underline;">{{
              urlCode
            }}</span></p>
          <br>
          <van-button
            size="small"
            round
            type="danger"
            block
            class="custom-btn"
            @click="qrCodeCopy"
            style="color: #ffffff; background-color: #EE5C35 ;border: 1px solid #EE5C35;"
            >复制推广码</van-button
          >
        </div>
        <br>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  name: "AgencyLink",
  data() {
    return {
      agencyUrl: "",
      Width: "",
      urlCode: "",
      urlCopy :"",
    };
  },
  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    qrcode(width, url) {
      let qrcode = new QRCode("qrcode", {
        width: 135,
        height: 130,
        text: url, // 二维码地址
      });
    },
    getAgencyUrl(width) {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "agent_qrcode_multiple",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code == 1) {
            that.agencyUrl = resData.data;
            that.qrcode(width, resData.data['qr_url']);
            delete that.agencyUrl['qr_url']; 
            that.urlCode = that.agencyUrl[0].split("=")[1];
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          that.$toast.fail(that.$NoNetworkErrorMsg);
        });
    },
    getWidth() {
      let width = window.innerWidth / 2;
      this.getAgencyUrl(width);
    },
    getUserUrl(){
       let width = window.innerWidth / 2;
       let that = this;
       that
         .$http({
           url: "/",
           method: "post",
           data: {
             nozzle: "coupon_url_multiple",
             token: sessionStorage.getItem("token"),
           }
         })
         .then(function (res) {
           let resData = res.data;
           if (res.data.code == 1) {
             console.log(resData.data)
             that.agencyUrl = resData.data;
             that.agencyUrlSub1 = that.agencyUrl[0].split('=')[0]+"?code=" + sessionStorage.getItem("couponCode");
             that.urlCode = that.agencyUrl[0].split("=")[1];
             sessionStorage.setItem("qrcodeUrl",that.agencyUrl[0]);
             var subUrl = sessionStorage.getItem("qrcodeUrl");
             // that.$store.commit("qrCodeUrl", subUrl);
             // that.subUrlMethod();
             that.qrcode(width,that.agencyUrl[0]);
             // that.getCode();
           } else if (res.data.code == 0) {
             that.$message.error(res.data.msg);
           }
         });
       },
    handleCopy(urlCopy) {
      let url = urlCopy;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      this.$toast.success({
        message: "复制成功",
      });
      oInput.remove();
    },
    qrCodeCopy() {
      let oInput = document.createElement("input");
      oInput.value = this.urlCode;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      this.$toast.success({
        message: "复制成功",
      });
      oInput.remove();
    },
  },
  mounted: function () {
    this.isLogin();
    console.log(sessionStorage.getItem("couponCode"));
    if(sessionStorage.getItem("couponCode")) {
       this.getUserUrl();
     } else {
    this.getWidth();
     }
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.agency {
  margin-top: 15px;
  padding-left: 15px;
  padding-right: 15px;
  text-align: left;
  font-size: 13px;
  font-weight: bold;
}
.agency_qrcode {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  margin: auto; 
  border-radius: 10px;
  background-color: white;
  width: 80%; 
  max-width: 300px; 
}

.qrCodeCopy {
  width: 90%;
  margin: 0 auto;
}
.agencybox{
  padding: 25px 20px 10px 20px;
  background-size: 100% 25%;
  background-repeat: no-repeat;
  background-image: url("../assets/images/bgagent1.png") ;
  background-color: #EE5C35;
}
.linkbox1{
  background: linear-gradient(#FFF2E4, #FDCD9C);
  border: 1px solid #FDCD9C;
  border-radius: 20px;
  height: 50%;
}
.linkbox2{
  background: linear-gradient(#FFF2E4, #FDCD9C);
  border: 1px solid #FDCD9C;
  border-radius: 20px;
  /* height: 25vh; */
}
.custom-btn {
  font-size: 12px !important; 
  padding: 4px 8px !important; 
  height: 35px !important; 
  line-height: 1.2 !important; 
  width: 180px;
  margin-left: 20%;
}
.url-container {
  position: relative;
  padding-right: 90px; 
  margin: 10px 0;
}

.url-text {
  color: #EE5C35;
  text-decoration: underline;
  word-wrap: break-word;
  overflow-wrap: break-word;
  margin: 0;
}

.copy-btn {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 80px;
  height: 26px;
  padding: 0;
  font-size: 12px;
  line-height: 26px;
  color: #ffffff;
  background-color: #EE5C35;
  border: 1px solid #EE5C35;
  border-radius: 15px;
}


</style>



// WEBPACK FOOTER //
// src/components/AgencyLink.vue